<template>
	<div>
		<div class="f-bold f-16 f-c-black m-d-16">
			Pengantaran
			<span class="badge color-green m-l-4" v-if="pengantaran.status_antar === 2">
				<img src="../../../../../assets/icons/check-green-solid.svg" alt=""> Sudah Diantar
			</span>
			<span class="badge color-grey m-l-4" v-if="pengantaran.status_antar < 2">
				Belum Diantar
			</span>
			<span class="badge color-red m-l-4" v-if="pengantaran.status_antar === 3">
				Gagal Diantar
			</span>
		</div>

		<div class="d-flex-between-center m-d-8">
			<div class="f-regular f-16 f-c-midgrey">
				Kurir
			</div>
			<div class="f-regular f-16 f-c-black">
				{{ pengantaran.nama_kurir === "" ?  "-" : pengantaran.nama_kurir }}
			</div>
		</div>
		<div class="d-flex-between-center m-d-8">
			<div class="f-regular f-16 f-c-midgrey">
				{{ pengantaran.status_antar < 2 ? "Jadwal" : "Terantar pada" }}
			</div>
			<div class="f-regular f-16 f-c-black">
				{{ $moment(pengantaran.tanggal_antar).format("dddd, DD MMMM YYYY HH:mm") }}
			</div>
		</div>
		<div class="separator-line m-t-8 m-d-12"></div>

		<div class="f-regular f-14 f-c-midgrey m-d-4">Alamat Pengantaran</div>
		<div class="f-regular f-14 f-c-black">
			{{ pengantaran.alamat }}
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTransaksiDetailPengantaran",
	props: {
		pengantaran: Object
	}
}
</script>